import React, { Component } from "react";
import { CloseCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import {errorHandle} from "../../../Common/errorHandle";

// npm install --save-dev @iconify/react @iconify-icons/ant-design

// import { DatePicker, TimePicker } from "antd";
// import moment from "moment-timezone";

class ZipcodeDrawer extends Component {

  state = {}

  componentDidMount = async () => {
    this.setState({
      unselectedZipCodes: this.props?.InitialCleaning?.zipCodes?.data,
      selectedZipCodes: [],
      area_name: '',
      InitialCleaningData: this.props?.InitialCleaningData
    });
  }
  
  UNSAFE_componentWillReceiveProps = (props) => {
    if(props?.InitialCleaning?.error){
      errorHandle(props?.InitialCleaning?.error);
    }

    if(props?.InitialCleaning?.field_cleaning_update_error) {
      if(props?.InitialCleaning?.field_cleaning_update_error?.detail) {
        this.setState({error: props?.InitialCleaning?.field_cleaning_update_error?.detail});
      }
    } else if(props?.InitialCleaning?.save_area_errors) {
      if(props?.InitialCleaning?.save_area_errors?.detail) {
        this.setState({error: props?.InitialCleaning?.save_area_errors?.detail});
      }
    }

    if(props?.selectedRecord){
      this.setState({
        selectedZipCodes: [...Array.from(props?.selectedRecord?.zipcode)],
        unselectedZipCodes: this.state.unselectedZipCodes.filter(
          (zip) => !props?.selectedRecord?.zipcode?.has(zip)
        ),
        area_name: props?.selectedRecord?.area,
        isEdit: true,
      });
    } else {
      this.setState({
        unselectedZipCodes: this.props?.InitialCleaning?.zipCodes?.data,
        selectedZipCodes: [],
        area_name: '',
        InitialCleaningData: this.props?.InitialCleaningData,
        isEdit: false,
      });
    }
  }

  generateRequestData = () => {

    // remove the error
    const { props } = this;
    if(props?.clearError) {
      if(props?.InitialCleaning?.field_cleaning_update_error) {
        props.clearError("field_cleaning_update_error");
      } else if(props?.InitialCleaning?.save_area_errors) {
        props.clearError("save_area_errors");
      }
    }

    let new_data = ["mon","tues","wed","thurs","fri","sat","sun"].map(day => ({
      field_office: this.props.history.location.state.query.data.uuid,
      area: this.state.area_name,
      zip_codes: this.state.selectedZipCodes,
      setup_day: day
    }));

    let request_data = [
      ...(this.props.initialCleaningToSaveRequest(this.state.InitialCleaningData)),
      ...new_data
    ]

    return request_data;
  }

  generateUpdateRequestData = () => {

    // console.log({data: this.props.initialCleaningToSaveRequest(this.state.InitialCleaningData), records: this.props.selectedRecord.uuids.map(x => (Object.values(x)[0]))});

    let request_data = [
      //fields that are not changed
      ...(this.props.initialCleaningToSaveRequest(this.state.InitialCleaningData).filter(({uuid}) => {
        return !(this.props.selectedRecord.uuids || []).includes(uuid);
      })),
      //fields that are changed
      ...(this.props.initialCleaningToSaveRequest(this.state.InitialCleaningData).filter(({uuid}) => {
        return !!(this.props.selectedRecord.uuids || []).includes(uuid);
      }).map((record) => {
        return {
          ...record,
          zip_codes: this.state.selectedZipCodes,
          area: this.state.area_name,
        };
      }))
    ]

    return request_data;
  }

  saveArea = () => {
    let request_data 
    if(!this.state.isEdit) {
      request_data = this.generateRequestData();
    } else {
      request_data = this.generateUpdateRequestData();
    }
    this.props.saveArea(request_data);
  }

  selectZipCode = (zipcode) => {
    this.setState({
      selectedZipCodes: [...this.state.selectedZipCodes, zipcode],
      unselectedZipCodes: this.state.unselectedZipCodes.filter(
        (zip) => zip !== zipcode
      ),
      error: null,
    });
  }

  unselectZipCode = (zipcode) => {
    this.setState({
      selectedZipCodes: this.state.selectedZipCodes.filter(
        (zip) => zip !== zipcode
      ),
      unselectedZipCodes: [...this.state.unselectedZipCodes, zipcode],
      error: null,
    });
  }

  updateFiled = (e) => {
    if(!e?.target) {
      return;
    }
    
    e.preventDefault();
    
    this.setState({
      [e.target.name]: e.target.value,
      error: null,
    });
  }

  validate = () => {
    if(this.state.area_name === '') {
      this.setState({error: 'Area name is required'});
      return false;
    }

    if(this.state.selectedZipCodes?.length === 0) {
      this.setState({error: 'At least one zip code is required'});
      return false;
    }
    
    return true;
  }

  render() {
    return (
      <div className="reschedule_service_wrapper rdrawer">
        <div className="card-row">
          <div className="card-full">
            <h4>Manage Zipcode for SW1</h4>
            <div className="fitem mb-10">
              <label>Area Name</label>
              <input type="text"
                className="form-control"
                placeholder="SW1"
                name="area_name"
                value={this.state.area_name}
                onChange={this.updateFiled}
              />
            </div>
            <div className="zip-blocks mb-20">
              <h6>Current Zipcodes</h6>
              <ul className="zip-list d-flex flex-wrap">
                {/* sample: <li>
                    60608 <CloseCircleOutlined />
                  </li> */}
                {
                    this.state.selectedZipCodes?.map((zipcode, index) => {
                      return (
                        <li key={index}>
                          {zipcode} <CloseCircleOutlined onClick={() => {
                            this.unselectZipCode(zipcode);
                          }} className="green-text"/>
                        </li>
                      )
                    })
                }
                  
              </ul>
            </div>
            <div className="zip-blocks">
              <h6>Add Zipcodes to area</h6>
              <ul className="zip-list d-flex flex-wrap">
                {/* sample: <li>
                    60608 <PlusCircleOutlined className="green-text"/>
                  </li> */}
                {
                    this.state.unselectedZipCodes?.map((zipcode, index) => {
                      return (
                        <li key={index}>
                          {zipcode} <PlusCircleOutlined onClick={() => {
                            this.selectZipCode(zipcode);
                          }} className="green-text"/>
                        </li>
                      )
                    })
                }
              </ul>
            </div>
            {!!this.state.error && <div
              style={{
                color: "red",
                padding: "10px",
                marginTop: "15px",
                border: "red 1px solid",
                background: "rgba(255,0,0,0.1)",
                borderRadius: "5px",
              }}
            >
              {
                this.state.error
              }
            </div>}
          </div>
        </div>
        <div className="footer">
          <button
            className="btn btn-brand btn-bdr"
            onClick={() => {
              this.props.showZipcodeDrawer(false);
            }}
          >
            Cancel
          </button>
          <button
            className="btn btn-warning"
            onClick={() => {
              if(this.validate()) {
                this.saveArea();
              }
            }}
          >
            Save Area
          </button>
        </div>
      </div>
    );
  }
}

export default ZipcodeDrawer;
